import React from 'react'
import EventCard from "./EventCard";
import { ThreeDots } from  'react-loader-spinner'


const EventList = ({cardInfo,fetchStatus}) => {
    return ( 
        <div  style={{minHeight:"300px",width:"100%"}} className="container d-flex  flex-wrap align-items-center justify-content-center">                
        {
            fetchStatus==="loading" && <ThreeDots height="100" width="100" color='grey' ariaLabel='loading'/>
        }

        { cardInfo.map(card => { return <EventCard key={card.id} cardInfo={card} /> }) }

        { 
            (fetchStatus!=="loading" && cardInfo.length === 0) && <div className="h3 text-center">No Events Found</div>
        }

        

        </div>

     );
}
 
export default EventList;